import { saveAs } from 'file-saver';
import mapboxgl from 'mapbox-gl';

/*export function convertBoundingBoxToCenter(bbox3857) {
    // Define the EPSG:3857 and EPSG:4326 coordinate systems
    const EPSG3857_SRID = 3857;
    const EPSG4326_SRID = 4326;

    // Helper function to convert degrees to radians
    function degreesToRadians(degrees) {
        return degrees * (Math.PI / 180);
    }

    // Convert EPSG:3857 to EPSG:4326
    const bbox4326 = bbox3857.map((coord, index) => {
        const srid = index % 2 === 0 ? EPSG3857_SRID : EPSG4326_SRID;
        const [x, y] = index % 2 === 0 ? [coord, bbox3857[index + 1]] : [bbox3857[index - 1], coord];

        const lonLat = [
            x / 111319.49079327358,
            y / 111319.49079327358
            //(Math.PI / 2) - (2 * Math.atan(Math.exp(-y / 111319.49079327358)))
        ];
        (bbox3857[0] + bbox3857[1])/(2*111319.49079327358)
        //return lonLat

        return srid === EPSG4326_SRID ? lonLat : lonLat.map(degreesToRadians);
    });

    // Calculate the center point of the converted bounding box
    const centerLongitude = (bbox4326[0] + bbox4326[2]) / 2;
    const centerLatitude = (bbox4326[1] + bbox4326[3]) / 2;

    // Return the center point coordinates
    return [centerLongitude, centerLatitude];
}*/

//TODO: improve the next function
export function convertBoundingBoxToCenter(bbox3857) {
    //const coords = new mapboxgl.MercatorCoordinate( (bbox3857[1] + bbox3857[3])/(2*111319.49079327358), (bbox3857[0] + bbox3857[2])/(2*111319.49079327358))
    const x = (bbox3857[0] + bbox3857[2]) / 2
    const y = (bbox3857[1] + bbox3857[3]) / 2
    const coords = [x / 111319.49079327358, (Math.PI / 2) - (2 * Math.atan(Math.exp(-y / 111319.49079327358)))]
    return [(bbox3857[0] + bbox3857[2]) / (2*111319.49079327358) -0.5, (bbox3857[1] + bbox3857[3]) / (2*111319.49079327358) - coords[1]]
}

// Usage example:
//const bbox3857 = [xmin, ymin, xmax, ymax]; // Replace with your actual bounding box coordinates
//const centerPoint = convertBoundingBoxToCenter(bbox3857);
//console.log(centerPoint); // [centerLongitude, centerLatitude]


export function getCenterBbox(bbox, factor = 1) {
    return [(bbox[0] + bbox[2]) * factor / 2, (bbox[1] + bbox[3]) * factor / 2]
}

export function exportMapPNG(map) {
    map.once('idle', () => {
        map.getCanvas().toBlob(function(blob) {
            saveAs(blob, 'map.png');
        })
    })
}

export function fly(map, storm) {
    map.flyTo({
        center: getCenterBbox(storm.bbox),
        zoom: 4.1,
        essential: true,
        bearing: 0,
        speed: 1, // make the flying slow
        //easing: (t) => t,
    })
}

export function flyToFlood(map, selectedFloodData) {
    map.flyTo({
        center: convertBoundingBoxToCenter(selectedFloodData.bbox_max),
        zoom: 8,
        essential: true,
        bearing: 0,
        speed: 1, // make the flying slow
        easing: (t) => t,
    })
}

export function coordinatesGeocoder(query) {
// Match anything which looks like
// decimal degrees coordinate pair.
    const matches = query.match(
        /^[ ]*(?:Lat: )?(-?\d+\.?\d*)[, ]+(?:Lng: )?(-?\d+\.?\d*)[ ]*$/i
    );
    if (!matches) {
        return null;
    }

    function coordinateFeature(lng, lat) {
        return {
            center: [lng, lat],
            geometry: {
                type: 'Point',
                coordinates: [lng, lat]
            },
            place_name: 'Lat: ' + lat + ' Lng: ' + lng,
            place_type: ['coordinate'],
            properties: {},
            type: 'Feature'
        };
    }

    const coord1 = Number(matches[1]);
    const coord2 = Number(matches[2]);
    const geocodes = [];

    if (coord1 < -90 || coord1 > 90) {
// must be lng, lat
        geocodes.push(coordinateFeature(coord1, coord2));
    }

    if (coord2 < -90 || coord2 > 90) {
// must be lat, lng
        geocodes.push(coordinateFeature(coord2, coord1));
    }

    if (geocodes.length === 0) {
// else could be either lng, lat or lat, lng
        geocodes.push(coordinateFeature(coord1, coord2));
        geocodes.push(coordinateFeature(coord2, coord1));
    }

    return geocodes;
};
